/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useEffect, useState } from "react";

import { querySystemConfigurations } from "src/services/AmplifyQuery";

/**
 * The SystemConfig component
 *
 * @author Thais Watanabe
 */
const SystemConfig = () => {
  const [systemConfig, setSystemConfig] = useState(null);

  /* useEffect */
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
  }, []);

  /* useEffect */
  useEffect(() => {
    fetchSystemConfigs();
  }, []);

  /**
   * fetchWindFarms
   */
  async function fetchSystemConfigs() {
    querySystemConfigurations(null, setSystemConfig);
  }

  return (
    <>
      <section aria-labelledby="billing_history_heading">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
          <div className="flex items-center space-x-5">
            <div>
              <h2
                id="billing_history_heading"
                className="text-lg leading-6 font-medium text-gray-900"
              >
                システム情報
              </h2>
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <tbody className="bg-white divide-y divide-gray-200">
              {!systemConfig && (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                  >
                    <div className="loader"></div>
                  </td>
                </tr>
              )}
              {systemConfig && (
                <>
                  <tr>
                    <th
                      scope="col"
                      className="bg-gray-50 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      システム名
                    </th>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {systemConfig.name}
                    </td>
                  </tr>
                  <tr>
                    <th
                      scope="col"
                      className="bg-gray-50 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      バージョン
                    </th>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {systemConfig.systemVersion}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default SystemConfig;
